import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, Button, Input } from 'semantic-ui-react';
import './ServiceManagerRoute.css';

import "semantic-ui-css/components/label.min.css";
import "semantic-ui-css/components/card.min.css";
import "semantic-ui-css/components/icon.min.css";

export default class ServiceManager extends Component {
  static propTypes = {
    services: PropTypes.array,
    restartService: PropTypes.func,
    getServices: PropTypes.func,
    restarting: PropTypes.bool,
    loading: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.props.getServices()
    this.state = {
      search: ''
    }
  }

  search = (e, { value }) => this.setState({ search: value })

  render() {
    return (
      <div className="ServiceManagerRoute">
        <h3>Manage Services</h3>
        <Input className="Search" placeholder='Search...' value={this.state.search} onChange={this.search} />
        <Card.Group
          loading={this.props.loading}
          items={this.props.services ? this.props.services.filter(service => service.name.includes(this.state.search)).map(service => ({
            header: <div className="custom-header" dangerouslySetInnerHTML={{ __html: service.name.replace(this.state.search, `<b>${this.state.search}</b>`) }} />,
            meta: service.flagged ? `flagged for restart by ${service.lastUser}` : `last restart by ${service.lastUser}`,
            key: service.pid,
            description: !service.flagged ? <Button loading={this.props.restarting} style={{ width: '100%'}} compact onClick={() => this.props.restartService(service.pid)}>Flag For Restart</Button> : null
          })) : []}
        />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ServiceManagerRouteComponent/ServiceManagerRoute.js